// routes/SessionRestoring.tsx — what the app shows while it is still reading the stored
// session, before it knows whether anyone is signed in.
//
// F-137: the router used to answer that question early, with `user === null`, and a deep
// link was bounced to /signin and from there to /home. The honest answer at that moment is
// "not yet known", and this is what it looks like. It deliberately paints NEITHER the home
// screen NOR a sign-in prompt — showing a refusal before the answer is known is the same
// defect wearing different clothes.

import React from "react";
import { IonSpinner } from "@ionic/react";

const SessionRestoring: React.FC = () => (
  <div
    data-testid="session-restoring"
    role="status"
    aria-live="polite"
    aria-busy="true"
    className="flex h-full w-full items-center justify-center"
  >
    <IonSpinner name="dots" />
    <span className="sr-only">Restoring your session</span>
  </div>
);

export default SessionRestoring;
